/* 三國逗陣打 · 元素與元素反應（掛在模擬層 World 上，不碰 DOM）
 * 每個主動技能有一個元素（火冰雷風毒暗光土，或無屬性）。帶元素的技能命中敵人會留下「印記」4 秒；
 * 另一種元素再打中有印記的目標就觸發反應。地形也算：站在江裡的人是「濕」的，蘆葦叢會被火點燃。
 * 技能執行期間 World._el 是當下的元素；投射物、區域、延遲效果建立時會記住它，之後造成傷害時再還原。 */
// @ts-nocheck — 第 2 步只把檔案改成模組，型別在第 4 步補
import { SG } from './sg.ts';

const W = SG.World.prototype, M = SG.MAP;
const gd = SG.gd;

const EL = {
  fire: { name: '火', col: '#ff8a3a', glow: '255,138,58' },
  ice: { name: '冰', col: '#8fd8ff', glow: '143,216,255' },
  thunder: { name: '雷', col: '#ffe95a', glow: '255,233,90' },
  wind: { name: '風', col: '#9ff0c8', glow: '159,240,200' },
  poison: { name: '毒', col: '#9be05a', glow: '155,224,90' },
  shadow: { name: '暗', col: '#b07cff', glow: '176,124,255' },
  holy: { name: '光', col: '#ffe9a8', glow: '255,233,168' },
  earth: { name: '土', col: '#d8a860', glow: '216,168,96' },
};
SG.EL = EL;

// 名稱優先，其次說明文字；順序決定衝突時誰贏（「爆雷」算雷不算火）
const RULES = [['thunder', /雷|電|霹|靂/], ['ice', /冰|凍|霜|寒|雪|水/], ['fire', /火|燃|炎|焚|焰|燒|爆/], ['earth', /地|崩|跺|裂|泰山|巨石|岩/], ['poison', /毒|蠱|瘴/], ['shadow', /鬼|妖|魅|幻|迷|暗|影|魂|惑|懼|恐|屍/], ['wind', /風|旋|颶|捲/], ['holy', /治療|恢復|回復|聖|光|仁|祝|淨化/]];
const ARCH_EL = { thunder: 'thunder', fire: 'fire', heal: 'holy', stealth: 'shadow', roar: 'wind', command: 'holy', shield: 'holy', slam: 'earth', spikes: 'earth' };
function elOf(sk, heroId) {
  if (!sk || sk.passive) return null;
  if (sk._el !== undefined) return sk._el;
  let el;
  if (sk.el !== undefined) el = sk.el; // 關鍵字判斷不準的，直接在武將檔的技能資料寫 el（null 表示無元素）
  else {
    for (const [e, re] of RULES) if (re.test(sk.name)) { el = e; break; }
    if (!el) for (const [e, re] of RULES) if (re.test(sk.desc)) { el = e; break; }
    if (!el) el = ARCH_EL[sk.arch] || (sk.pal === 'ice' ? 'ice' : sk.pal === 'poison' ? 'poison' : sk.pal === 'fire' ? 'fire' : null);
  }
  sk._el = el || null;
  return sk._el;
}
SG.elOf = elOf;
// 建立武將時把元素寫進技能資料，畫面層與說明都讀這個
SG.HEROES.forEach((h) => (h.forms ? h.forms.map((f) => f.spec) : [h]).forEach((s) => s.skills.forEach((sk) => { elOf(sk, h.id); if (sk.then) elOf(sk.then, h.id); }))); // 形態：每個形態的技能都要

const REACT = {
  melt: { name: '融化', col: '#ffb070', desc: '火打冰、冰打火：傷害 ×1.5' },
  shatter: { name: '碎冰', col: '#cfefff', desc: '雷或土打冰：傷害 +40%、暈眩 0.6 秒；打在凍結的人身上 ×1.8' },
  conduct: { name: '導電', col: '#fff07a', desc: '雷打濕的人（在江裡或有冰印記）：電流跳到附近 3 名濕的敵人，各受 60% 傷害' },
  firestorm: { name: '火旋風', col: '#ff7a3a', desc: '火與風相遇：原地捲起 3 秒的火旋風' },
  burst: { name: '毒爆', col: '#c8f05a', desc: '火或雷打中毒的人：周圍爆開，濺射 50% 傷害並讓人中毒' },
  spread: { name: '擴散', col: '#b8ffe0', desc: '風打中有印記的人：把印記吹到周圍敵人身上，傷害 +20%' },
  purge: { name: '破邪', col: '#fff4c8', desc: '光與暗相剋：傷害 ×1.6' },
  drain: { name: '侵蝕', col: '#c9a2ff', desc: '暗打中有其他印記的人：破甲 3 秒、吸取 25% 傷害' },
  crystal: { name: '結晶', col: '#f0d08a', desc: '土打中有火、雷、毒印記的人：施放者獲得 20% 傷害的護盾' },
  freeze: { name: '凍結', col: '#9fe7ff', desc: '冰打濕的人：凍結 0.9 秒' },
  steam: { name: '蒸發', col: '#e8eef2', desc: '火打濕的人：傷害只剩 80%，冒出一團蒸氣' },
  wildfire: { name: '燎原', col: '#ff9a3a', desc: '火打中蘆葦叢裡的人：整叢燒起來 4 秒' },
};
SG.REACT = REACT;

// 站在浮橋上不算濕：橋面沿路線鋪、寬 184（見 map.js M.onBridge）
const onBridge = (x, y) => !!(M.onBridge && M.onBridge(x, y));
// 技能鋪的水域（v0.5.3，凌統「旋風棍」、孫權的水球、長江天塹、濡須潮界）：look 'water' 或標了 water 的地面區域
SG.waterZoneAt = (w, x, y) => !!(w && w.zones && w.zones.some((z) => (z.look === 'water' || z.water) && !(z.t <= 0) && gd(z.x, z.y, x, y) <= z.r));
// 「在水裡」（甘寧錦帆、孫權被動）：江面（不含浮橋）、淺灘、技能鋪的水域、荀攸決水灌城，或冰（水）系技能留在地上的範圍
SG.inWaterArea = (w, u) => M.waterAt(u.x, u.y) || u.floodT > 0 || SG.waterZoneAt(w, u.x, u.y)
  || !!(w && w.zones && w.zones.some((z) => z.el === 'ice' && !(z.t <= 0) && gd(z.x, z.y, u.x, u.y) <= z.r));
const wet = (w, t) => M.waterAt(t.x, t.y) || t.floodT > 0 || SG.waterZoneAt(w, t.x, t.y); // 江面（不含浮橋）、淺灘、技能鋪的水域；floodT：荀攸「決水灌城」的水域
SG.inWater = (x, y) => Math.abs(M.riverDist(x, y)) < M.river.hw && !onBridge(x, y); // 只算江面（徐盛「迎風破浪」寫的是河道）；淺灘另外用 M.waterAt
W.isWet = function (t) { return wet(this, t) || (t.mk && t.mk.el === 'ice'); };

// 目前的元素：明確給的 o.el 優先（null 代表刻意無屬性），普攻沒有元素
W.elNow = function (o) { return o.el !== undefined ? o.el : o.basic ? null : this._el || null; };

// damage() 在扣血前呼叫，回傳調整後的傷害
W.react = function (src, t, a, o) {
  const el = this.elNow(o), own = src.owner || src;
  if (!el || t.structure || t.kind === 'cart' || !t.alive || own.kind !== 'hero') return a;
  const mk = t.mk && t.mk.t > 0 ? t.mk.el : null, now = this.t;
  const cool = t.rxT && now - t.rxT < 0.6;
  let r = null;
  if (!cool) {
    if ((el === 'fire' && mk === 'ice') || (el === 'ice' && mk === 'fire')) r = 'melt';
    else if ((el === 'thunder' || el === 'earth') && (mk === 'ice' || t.st.freeze > 0)) r = 'shatter';
    else if (el === 'thunder' && wet(this, t)) r = 'conduct';
    else if ((el === 'fire' && mk === 'wind') || (el === 'wind' && mk === 'fire')) r = 'firestorm';
    else if ((el === 'fire' || el === 'thunder') && mk === 'poison') r = 'burst';
    else if (el === 'wind' && mk && mk !== 'wind') r = 'spread';
    else if ((el === 'holy' && mk === 'shadow') || (el === 'shadow' && mk === 'holy')) r = 'purge';
    else if (el === 'shadow' && mk && mk !== 'shadow') r = 'drain';
    else if (el === 'earth' && (mk === 'fire' || mk === 'thunder' || mk === 'poison')) r = 'crystal';
    else if (el === 'ice' && wet(this, t) && !mk) r = 'freeze';
    else if (el === 'fire' && wet(this, t)) r = 'steam';
    else if (el === 'fire' && t.brush >= 0 && !(this.brushFire && this.brushFire[t.brush] > now)) r = 'wildfire';
  }
  if (r) {
    t.rxT = now;
    const ctx = { el: null, quiet: false, react: true };
    switch (r) {
      case 'melt': a *= 1.5; t.mk = null; break;
      case 'shatter': a *= t.st.freeze > 0 ? 1.8 : 1.4; t.st.freeze = 0; t.mk = null; this.applyCC(own, t, { stun: 0.6 }); break;
      case 'conduct': {
        const hits = this.units.filter((o2) => o2 !== t && this.hostile(own, o2) && !o2.structure && this.isWet(o2) && gd(o2.x, o2.y, t.x, t.y) < 300).slice(0, 3);
        const pts = [[t.x, t.y]];
        this.later(0.08, () => hits.forEach((o2) => { if (o2.alive) { this.damage(own, o2, a * 0.6, ctx); pts.push([o2.x, o2.y]); } }));
        this.fx({ k: 'chainzap', x: t.x, y: t.y, pts: hits.map((o2) => [o2.x, o2.y]) });
        break;
      }
      case 'firestorm':
        t.mk = null;
        this.zone(own, { x: t.x, y: t.y, r: 110, t: 3, tick: 0.4, dmg: Math.max(15, a * 0.12), ground: false, fire: true, pal: 'fire', el: null, storm: 1, vortex: 1 });
        break;
      case 'burst':
        t.mk = null;
        this.units.filter((o2) => o2 !== t && this.hostile(own, o2) && !o2.structure && gd(o2.x, o2.y, t.x, t.y) < 140).forEach((o2) => { this.damage(own, o2, a * 0.5, ctx); this.mark(o2, 'poison', own); });
        break;
      case 'spread': {
        a *= 1.2;
        const m0 = mk;
        this.units.filter((o2) => o2 !== t && this.hostile(own, o2) && !o2.structure && gd(o2.x, o2.y, t.x, t.y) < 180).forEach((o2) => this.mark(o2, m0, own));
        break;
      }
      case 'purge': a *= 1.6; t.mk = null; break;
      case 'drain': t.st.shred = Math.max(t.st.shred, 3); this.heal(own, a * 0.25); t.mk = null; break;
      case 'crystal': own.st.shield = (own.st.shield || 0) + a * 0.2; own.st.shieldT = Math.max(own.st.shieldT, 4); t.mk = null; break;
      case 'freeze': this.applyCC(own, t, { freeze: 0.9 }); break;
      case 'steam': a *= 0.8; this.zone(own, { x: t.x, y: t.y, r: 90, t: 1.5, tick: 9, dmg: 0, el: null, steam: 1 }); break;
      case 'wildfire':
        (this.brushFire || (this.brushFire = {}))[t.brush] = now + 8;
        this.zone(own, { x: t.x, y: t.y, r: 130, t: 4, tick: 0.5, dmg: Math.max(12, a * 0.1), ground: true, fire: true, pal: 'fire', el: null, wild: 1 });
        break;
    }
    this.fx({ k: 'react', r, x: t.x, y: t.y, el });
    const R = REACT[r];
    if (own.human || t.human || (this.player && gd(t.x, t.y, this.player.x, this.player.y) < 700)) this.dmgEvents.push({ x: t.x, y: t.y - 70, text: R.name, col: R.col, react: 1, team: t.team, src: own.id });
    if (own.stat) own.stat.react = (own.stat.react || 0) + 1;
    // 反應後不留新印記（融化、碎冰等已經消耗掉），但擴散、導電、燎原會留下打中的元素
    if (r === 'spread' || r === 'conduct' || r === 'wildfire' || r === 'freeze' || r === 'steam') this.mark(t, el, own);
    return a;
  }
  this.mark(t, el, own);
  return a;
};

W.mark = function (t, el, own) {
  if (!el || t.structure || t.kind === 'cart' || !t.alive) return;
  if (el === 'holy' && own && own.team === t.team) return;
  t.mk = { el, t: 4, by: own ? own.id : 0 };
};

// 每步呼叫：印記倒數；冰印記讓人慢 15%
W.elTick = function (dt) {
  for (const u of this.units) {
    if (!u.mk) continue;
    u.mk.t -= dt;
    if (u.mk.t <= 0 || !u.alive) { u.mk = null; continue; }
    if (u.mk.el === 'ice' && !(u.st.slow > 0 && u.st.slowAmt > 0.15)) { u.st.slow = 0.2; u.st.slowAmt = 0.15; }
  }
};
